module.exports = __webpack_public_path__ + "static/media/randomBoxImg.7740faf7.png";